import React, {Component, PropTypes} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  Icon,
  Button,
  PanelFooter,
  Form,
  FormGroup,
  HelpBlock,
  ControlLabel,
} from '@sketchpixy/rubix';

import RoleType from '../../../RoleGroup/Roles/RoleType';
import {checkRole} from '../../../../util/RoleChecker';
import {getRoleDetail, updateRole} from '../../../../api/api';
import {routeUrl} from '../../../routeUrl';
import Roles from '../Roles';
import _ from 'lodash';

class EditRole extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: 'Create Role',
      editButtonName: 'Create',
      role: {roleActivation: 1},
    };
  }

  componentDidMount() {
    const requiredRoles = [
      RoleType.PERMISSION_GROUP,
    ];

    checkRole(requiredRoles, this.props.router);

    Messenger.options = {
      theme: 'flat',
    };

    const roleId = this.props.params.roleId;
    if(roleId)
    {
        getRoleDetail(roleId, (err, result) => {
            if (err) {
              this.props.router.push(routeUrl.login);
            } else {
              this.setState({
                role: result.role,
                title: 'Edit Role',
                editButtonName: 'Update',
              });
            }
        });
    }
  }

  roleNameChangeHandler = (event) => {
    this.setState({role: {...this.state.role, roleName: event.target.value}});
  };

  roleDescriptionChangeHandler = (event) => {
    this.setState({role: {...this.state.role, roleDescription: event.target.value}});
  };

  rolePatternChangeHandler = (event) => {
    this.setState({role: {...this.state.role, rolePattern: event.target.value}});
  };
  roleEnumKeyChangeHandler = (event) => {
    this.setState({role: {...this.state.role, roleEnumKey: event.target.value}});
  };
  roleActivationChangeHandler = (event) => {
    this.setState({role: {...this.state.role, roleActivation: event.target.value}});
  };

  goBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.router.goBack();
  };

  updateRoleHandler = () => {
    if (this.state.role.roleName.length === 0) {
      return alert('Please input role group name.');
    }

    updateRole(this.state.role, (err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.props.router.goBack();
      }
    });

  };

  render() {
    return (
        <PanelContainer controls={false}>
          <Panel>
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3>
                      <Icon glyph='icon-fontello-edit' />
                      &nbsp; {this.state.title}
                    </h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Form>
                      <FormGroup controlId='name'>
                        <ControlLabel>Name</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Enter Role Name"
                            value={this.state.role.roleName}
                            onChange={this.roleNameChangeHandler}
                        />
                        <HelpBlock>Specify a permission name.</HelpBlock>
                      </FormGroup>

                      <FormGroup controlId='description'>
                        <ControlLabel>Description</ControlLabel>
                        <FormControl
                            type="text"
                            placeholder="Enter Role Description"
                            value={this.state.role.roleDescription}
                            onChange={this.roleDescriptionChangeHandler}
                        />
                        <HelpBlock>Optional.</HelpBlock>
                      </FormGroup>
                      
                      
                    
                    <FormGroup controlId='pattern'>
                       <ControlLabel>Pattern</ControlLabel>
                       <FormControl
                           type="text"
                           placeholder="Enter Role Pattern"
                           value={this.state.role.rolePattern}
                           onChange={this.rolePatternChangeHandler}
                       />
                       <HelpBlock>Specify a Role Pattern.</HelpBlock>
                    </FormGroup>
                  
                  <FormGroup controlId='enumkey'>
                  <ControlLabel>Enum Key</ControlLabel>
                  <FormControl
                      type="text"
                      placeholder="Enter Role Key"
                      value={this.state.role.roleEnumKey}
                      onChange={this.roleEnumKeyChangeHandler}
                  />
                  <HelpBlock>Specify a Role Key.</HelpBlock>
                </FormGroup>
                <FormGroup controlId='activation'>
                   <ControlLabel>Activation</ControlLabel>
                   <FormControl
                   onChange={this.roleActivationChangeHandler}
                   value={this.state.role.roleActivation}
                   componentClass="select"
                   style={{width: '120px'}}
                   >
                       <option key='Active' value='1'>Active</option>
                       <option key='Inactive' value='0'>Inactive</option>
                   </FormControl>
                 </FormGroup>
                    </Form>
                  </Col>
                </Row>
              </Grid>
            </PanelBody>
            <PanelFooter className='bg-pinkishred'>
              <Grid>
                <Row>
                  <Col xs={12} className='fg-white'>
                    <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                      <Button bsStyle='brownishgray' onClick={this.goBack} style={{marginRight: '8px'}}>Cancel</Button>
                      <Button bsStyle='brownishgray' onClick={this.updateRoleHandler}>
                        {this.state.editButtonName}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </PanelFooter>
          </Panel>
        </PanelContainer>
    );
  }
}

EditRole.propTypes = {};

export default EditRole;



// WEBPACK FOOTER //
// ./src/routes/permission/Role/components/EditRole.js